import Student from "./Student";

export default Student;
